export const INVOICES_SEARCH = 'INVOICES_SEARCH';
export const INVOICE_VIEW = 'INVOICE_VIEW';
export const INVOICE_VIEW_LOADED = 'INVOICE_VIEW_LOADED';
